"use strict";

var _toConsumableArray = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hex_1 = require("../hex");

var encodeHelpers_1 = require("./encodeHelpers");

function encodePacked() {
  var preparedArgs = [];

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  for (var _i = 0, _args = args; _i < _args.length; _i++) {
    var arg = _args[_i];
    var preparedArg = null;

    if (arg && typeof arg === 'object') {
      if (arg.type && arg.value) {
        preparedArg = arg;
      } else if (arg.t && arg.v) {
        var type = arg.t,
            value = arg.v;
        preparedArg = {
          type: type,
          value: value
        };
      }
    }

    if (!preparedArg) {
      var _type = encodeHelpers_1.detectArgType(arg);

      if (_type) {
        preparedArg = {
          type: _type,
          value: arg
        };
      }
    }

    if (preparedArg) {
      preparedArgs.push(preparedArg);
    } else {
      throw new Error('unsupported encodePacked arg');
    }
  }

  return hex_1.concatHex.apply(hex_1, _toConsumableArray(preparedArgs.map(function (param) {
    return encodeHelpers_1.encodeArg(param, true);
  })));
}

exports.encodePacked = encodePacked;